
export enum PostSynchroActions {
  SMS = 'SMS',
  Email = 'Email',
  SocialWall = 'SocialWall',
  Transformation = 'Transformation',
  Clone = 'Clone'
}
